import { inject, injectable } from 'inversify';
import { NetworkDependencyTypes } from '@shared/common/network/network.dependency-types';
import type { JwtRepositoryInterface } from '@shared/common/network/domain/repository/jwt.repository';
import type { JwtRefreshService } from '@shared/common/network/domain/service/jwt-refresh.service';
import type { JwtRefreshGateway } from '@shared/common/network/domain/service/jwt-refresh.gateway';

@injectable()
export class DefaultJwtRefreshService implements JwtRefreshService {
  public constructor(
    @inject(NetworkDependencyTypes.JwtRefreshGateway)
    private readonly jwtRefreshGateway: JwtRefreshGateway,
    @inject(NetworkDependencyTypes.JwtRepository)
    private readonly jwtRepository: JwtRepositoryInterface,
  ) {}

  public async refresh(): Promise<string> {
    const token = await this.jwtRefreshGateway.refresh();
    this.jwtRepository.saveToken(token);

    return token;
  }
}
